import { call, put, takeEvery, all } from 'redux-saga/effects';
import { tableConfig } from 'src/settings';
import { logger } from 'src/helpers/logger';
import { sendRequest } from 'src/helpers/saga';
import { ICollectionResponse, IRequestParams, IResponse } from '@dash/apiInstance';
import { ISkill } from '@dash/skillApplication';
import ApiInstance from 'src/helpers/apiInstance';
import { t } from 'src/i18n';
import { executeAction } from 'src/helpers/api';
import { push } from 'redux-first-history';
import actions from './actions';
import { LoadSkillApplicationsRequestAction, ProcessActionRequestAction } from './actions.d';
import actionTypes from './actionTypes';
import { ILoadSkillApplicationsPathParams, IProcessActionResponse } from './types';
import notifications from '../../../redux/notifications/actions';

const api = new ApiInstance('dashboard/new_skills');

function* loadSkillApplications({ payload }: LoadSkillApplicationsRequestAction<ILoadSkillApplicationsPathParams, {}>) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;

    const result: ICollectionResponse<ISkill> = yield call<
      any,
      IRequestParams<ILoadSkillApplicationsPathParams, {}>,
      string
    >(sendRequest, api.get, { search: { page, pageSize, column, order, filter } }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(
        actions.loadSkillApplicationsSuccess({
          skillApplications: result.data?.records,
          total: result.data?.total,
          filteredTotal: result.data?.filteredCount,
          sortableColumns: result.data?.sortableColumns,
        }),
      );
    } else {
      yield put(actions.loadSkillApplicationsError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key, loadSkillsQuery } = payload;

    const params: IRequestParams<{}, {}> = { url, method };

    if (method?.toLowerCase() !== 'get') {
      params.data = data;
    }

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      params,
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      // @ts-ignore
      const newQueryParams = new URLSearchParams(loadSkillsQuery || {}).toString();
      const currentPath = window.location.pathname;

      switch (true) {
        case key === 'approve':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_approved_successful_text'),
            }),
          );

          // @ts-ignore
          yield put(actions.loadSkillApplicationsRequest(loadSkillsQuery));
          yield put(push(`${currentPath}?${newQueryParams}`));

          break;

        case key === 'deny':
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.landingPage.newSkillsApplications.skill_denied_successful_text'),
            }),
          );

          // @ts-ignore
          yield put(actions.loadSkillApplicationsRequest(loadSkillsQuery));
          yield put(push(`${currentPath}?${newQueryParams}`));
          break;
        default:
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: result?.messages?.join(' ') || '',
            }),
          );

          // @ts-ignore
          yield put(actions.loadSkillApplicationsRequest(loadSkillsQuery));
          yield put(push(`${currentPath}?${newQueryParams}`));
      }
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );

      yield put({ type: actionTypes.PROCESS_ACTION_ERROR });
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_SKILL_APPLICATIONS_REQUEST, loadSkillApplications)]);
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
